import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import './style.css';

const Lending = () => {
    const { t } = useTranslation();
    return (
        <div className="container-fluid">
            <div className="lending-page-container">
                <div className="container-fluid container-fluid-custom ">
                    <div>
                        <h1 className="lending-subtitle">{t('landing.title1')}</h1>
                        <h1 className="lending-subtitle">{t('landing.title2')}</h1>
                        <div className="download-box">
                            <h5>{t('landing.store_msg')}</h5>
                            <div className="app-stores">
                                <a href="https://apps.apple.com/us/app/pointsnaps/id1508279274?ls=1" target="_blank" rel="noopener noreferrer"> <img src="/assets/images/appStore.svg" alt=" App store" /></a>
                                <a href="https://play.google.com/store/apps/details?id=com.hyperether.pointsnaps" target="_blank" rel="noopener noreferrer"> <img src="/assets/images/googlePlay.svg" alt="Google Play" /></a>
                            </div>
                        </div>
                    </div>
                </div>
                <NavLink to="/terms" className="footer-conditions">{t('terms')} </NavLink>
            </div>
        </div>
    )
}
export default Lending;


// WEBPACK FOOTER //
// ./src/components/lendingComponent/lending.js